var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sales-link-view"},[(_vm.pageLoading)?_c('Spin',{attrs:{"fix":""}}):_vm._e(),(_vm.pageVisible)?_c('Table',{attrs:{"border":true,"max-height":700,"columns":_vm.tableColumns,"data":_vm.salesLinkData,"span-method":_vm.rowOrColMergeHand}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }